import { createRequestTypes } from '../utils';

export const COS_ANNEXE_TR_LIST = createRequestTypes('cosAnnexeTR/COS_ANNEXE_TR_LIST');
export const SAVE_COS_ANNEXE_TRs = createRequestTypes('cosAnnexeTR/SAVE_COS_ANNEXE_TRs');

